import { Component, OnInit } from '@angular/core';
import { AuthService } from '../core/auth.service';
import { Router } from '@angular/router';
import { IntercomService } from '../shared/intercom.service';

@Component({
  selector: 'app-shell',
  templateUrl: './app-shell.component.html',
  styleUrls: ['./app-shell.component.scss']
})
export class AppShellComponent implements OnInit {
  hotel: string;

  // AppShell is a protected route so they must be authenticated already
  // no point checking whether they are logged in
  constructor(
    public auth: AuthService,
    private router: Router,
    private intercom: IntercomService
  ) {}

  async ngOnInit() {
    // fine tune effects later
    this.auth.getCustomerNameP().then(
      name => {
        this.hotel = name;
      },

      err => {
        console.error('Failed to get customer name');
      }
    );

    // redirect from '/'
    if (this.router.url === '/') {
      if (!(await this.auth.hasSessionP())) {
        this.intercom.shutDownIntercom();
        this.router.navigate(['signin']);
      } else if (this.auth.isClientAdmin()) {
        this.router.navigate(['/users']);
      } else if (this.auth.isAdmin() || this.auth.isUser()) {
        this.router.navigate(['/locations']);
      }
    }
  }

  onLogout() {
    this.intercom.shutDownIntercom();
    this.auth.logout();
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/app-shell/app-shell.component.ts